import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './Contact.module.scss';

import {
  sendContactEmail,
  types as serviceTypes
} from 'legacy/actions/serviceActions';
import {
  showModal,
  modalComponentTypes,
  hideModal
} from 'legacy/actions/modalActions';

import { ValidatedInput, withForm } from '../../util/FormHelpers';
import {
  isRequired,
  isEmail,
  composeValidators
} from '../../../util/validators';

import ContactFormSubmit from '../../util/FormHelpers/ContactFormSubmit';
import { LoadingState, ErrorState } from 'legacy/reducers/types';

interface ContactFormData {
  name: string;
  email: string;
  subject: string;
  body: string;
}

interface ContactProps {
  service: {
    contactSent: boolean;
    loading: LoadingState;
    errors: ErrorState;
  };
  sendContactEmail: (data: ContactFormData) => void;
  showModal: (type: string, props: any) => void;
  hideModal: () => void;
  formProps: {
    form: { reset: () => void };
    values: ContactFormData;
    valid: boolean;
    dirtySinceLastSubmit: boolean;
    submitting: boolean;
    hasSubmitErrors: boolean;
    submitErrors: { FORM_ERROR?: string };
    handleSubmit: () => void;
  };
}

class Contact extends Component<ContactProps> {
  constructor(props: ContactProps) {
    super(props);
    this.state = {};
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  resetForm = () => {
    this.props.formProps.form.reset();
    this.props.hideModal();
  };

  componentDidUpdate = (prevProps: ContactProps) => {
    if (
      prevProps.service.loading.CONTACT_US &&
      !this.props.service.loading.CONTACT_US &&
      !this.props.service.errors.CONTACT_US.message
    ) {
      this.props.showModal(modalComponentTypes.ALERT, {
        message:
          'Your message has been received. We will be in touch as soon as possible!',
        onSuccess: this.resetForm,
        onRequestClose: this.resetForm,
        type: 'success'
      });
    }
  };

  handleSubmit = (e: React.FormEvent, formProps: ContactProps['formProps']) => {
    e.preventDefault();
    formProps.handleSubmit();
    if (formProps.valid || formProps.dirtySinceLastSubmit) {
      this.props.sendContactEmail(formProps.values);
    }
  };

  render() {
    const { formProps } = this.props;
    return (
      <div className={styles.Contact}>
        <h1>Got a Question?</h1>
        <p>
          We love to hear from you, whether you have a question, suggestion or
          complaint!
        </p>
        <form
          className={styles.Form}
          onSubmit={(e) => this.handleSubmit(e, formProps)}
        >
          <h3>Full Name</h3>
          <ValidatedInput
            type="text"
            name="name"
            placeholder="Richard Hendricks"
            validate={isRequired}
          />
          <h3>Email Address</h3>
          <ValidatedInput
            type="text"
            name="email"
            validate={(value: any) => {
              const result = composeValidators(isRequired, isEmail)(value, {});
              return typeof result === 'string' ? result : undefined;
            }}
            placeholder="r.hendricks@piedpiper.com"
          />
          <h3>Subject</h3>
          <ValidatedInput
            type="text"
            name="subject"
            placeholder="Pied Piper ICO"
            validate={isRequired}
          />

          <h3>Message</h3>
          <ValidatedInput
            id="textArea"
            placeholder="How can we help?"
            name="body"
            type="text"
            component="textarea"
            validate={isRequired}
            inputProps={{
              rows: 7,
              wrap: 'soft'
            }}
          />

          <div className="wrapper">
            <ContactFormSubmit
              errorOpen={
                formProps.hasSubmitErrors &&
                !formProps.dirtySinceLastSubmit &&
                !formProps.submitting
              }
              buttonText="Send"
              errorContent={
                formProps.hasSubmitErrors
                  ? formProps.submitErrors.FORM_ERROR || ''
                  : ''
              }
              loading={this.props.service.loading.CONTACT_US}
              disabled={false}
              type="primary"
            />
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({ service: state.service });

const actions = { sendContactEmail, showModal, hideModal };

export default connect(
  mapStateToProps,
  actions
)(withForm((serviceTypes as any).CONTACT_US_FORM)(Contact));
